import Api from '@/services/Api'

export default {
  index () {
    return Api().get('role')
  },
  show (roleID) {
    return Api().get(`role/${roleID}`)
  },
  post (role) {
    return Api().post('role', role)
  },
  put (role) {
    return Api().put(`role/${role.roleID}`, role)
  }
}



// WEBPACK FOOTER //
// ./src/services/RoleService.js